import * as React from 'react';
import * as Styles from './MembershipHeader.scss';

interface IOwnProps {
  title?: string;
  subTitle?: string;
}

const MembershipHeader: React.SFC<IOwnProps> = ({ title, subTitle }) => {
  return (
    <div className={Styles.header}>
      {title && <h2 className={Styles.title}>{title}</h2>}
      {subTitle && <p className={Styles.subTitle}>{subTitle}</p>}
    </div>
  );
};

export default MembershipHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/MembershipHeader/MembershipHeader.tsx